import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';
import { trackQueryError } from '@utils/sensor/apptracker';
import { getProfileApplications } from '@src/api/applications';

const defaultValue = null;

function useFetchApp() {
  const { isFetching, isLoading, data } = useQuery(
    ['profile', 'applications'],
    () => {
      return getProfileApplications().then((response) => {
        return get(response, ['data'], {});
      });
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: true,
      staleTime: 5 * 60 * 1000, // 5m
      placeholderData: defaultValue,
      keepPreviousData: true,
      onError: (err) => {
        trackQueryError({ type: 'profile-applications', err });
      },
    },
  );

  return {
    profiles: data,
    isLoading,
    isFetching,
  };
}

export default useFetchApp;
